import { IObjectDTO, TaskDTO } from '../../../api/plyca-dtos';

export class HelpDTO {
  version: string;
  content: Array<HelpElementDTO>;
}

export class HelpElementDTO {
  identifier: string;
  task: TaskDTO;
  type: string;
  locale: string;
  profiles: Array<string>;
  name: string;
  shortDesc: string;
  content: string;
  term: string;
  tags: Array<string>;
  // generalHelp: boolean;
  externalLink: string;
  multimediaLink: string;
  group: string;
  editor: string;
  orderStr: string;

  static patchDTO(dto: HelpElementDTO) {
    if (!dto.tags) {
      dto.tags = [];
    }
  }

  constructor() {
    HelpElementDTO.patchDTO(this);
  }
}

export class ContextHelp {
  searchTags: Array<string>;
  helpElements: Array<HelpElementDTO>;
  constructor(searchTags: Array<string>, helpElements: Array<HelpElementDTO>) {
    this.searchTags = searchTags;
    this.helpElements = helpElements;
  }
}

export enum HelpElementType {
  AYUDA = 'AYUDA',
  CASO_PRACTICO = 'CASO_PRACTICO',
  NOTA_INTERNA = 'NOTA_INTERNA',
  NORMATIVA = 'NORMATIVA',
  VIDEO = 'VIDEO'
}

export class DefinitionHelp extends HelpDTO {
  term: string;
}

export class GeneralHelpDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  name: string;
  description: string;
  locale: string;
  content: Array<GeneralHelpGroupContentsDTO>;

  static patchDTO(dto: GeneralHelpDTO) {
    if (!dto.content) {
      dto.content = [];
    }
  }

  constructor() {
    GeneralHelpDTO.patchDTO(this);
  }
}

export class GeneralHelpGroupContentsDTO {
  content: Array<GeneralHelpGroupDTO>;

  static patchDTO(dto: GeneralHelpGroupContentsDTO) {
    if (!dto.content) {
      dto.content = [];
    }
  }

  constructor() {
    GeneralHelpGroupContentsDTO.patchDTO(this);
  }
}

export class GeneralHelpGroupDTO {
  name: string;
  description: string;
  locale: string;
  content: Array<HelpElementDTO>;
  orderStr: string;

  static patchDTO(dto: GeneralHelpGroupDTO) {
    if (!dto.content) {
      dto.content = [];
    }
  }

  constructor() {
    GeneralHelpGroupDTO.patchDTO(this);
  }
}

export class HelpFileDTO {
  identifier: string;
  task: TaskDTO;
  version: string;
  description: string;
  locales: Array<string>;
  helpElements: Array<HelpElementDTO>;

  static patchDTO(dto: HelpFileDTO) {
    if (!dto.helpElements) {
      dto.helpElements = [];
    }
  }

  constructor() {
    HelpFileDTO.patchDTO(this);
  }
}
